import { Tab } from "./Tab/Tab";
import styles from "./Tabs.module.scss";

export const Tabs = ({ options = [] }) => {
  return <div className={styles.container}>
    {options.map((option, index) => <Tab key={index} option={option} />)}
  </div>;
};
